import React from 'react';
import {Helmet} from 'react-helmet';

import {LayoutConsumer} from 'contexts/layout-context';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

export default ({children}) => {
  return (
    <React.Fragment>
      <Helmet titleTemplate="%s | Litheness">
        <title>Gym</title>
      </Helmet>
      <LayoutConsumer>
        {({header, footer, sidebar}) => {
          return (
            <React.Fragment>
              {sidebar && header && <Header />}
              {sidebar && <div id="wrapper">
                <Sidebar />
                <div id="content-wrapper">
                  <div className="container-fluid position-relative">
                    {children}
                  </div>
                  {footer && <Footer />}
                </div>
              </div>}
              {!sidebar && children}
            </React.Fragment>
          );
        }}
      </LayoutConsumer>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Layouts/Root.js